import * as React from 'react';
import {
  CapitalConservativeIcon,
  CapitalBalancedIcon,
  CapitalUnconstrainedIcon,
  DigitalConservativeIcon,
  DigitalBalancedIcon,
  DigitalUnconstrainedIcon,
  DigitalIcon,
  CapitalIcon
} from '../../../assets/icons';
import { FundTypes } from '../../../models';
import { i18n } from '../../../i18n';
import Tooltip from '../../Tooltip/Tooltip';

interface InvChoicesButtonsProps {
  capitalFundSelected: FundTypes | null;
  digitalFundSelected: FundTypes | null;
  setDigitalFund: (x: FundTypes) => object;
  setCapitalFund: (x: FundTypes) => object;
  showTooltips?: boolean;
}

export default class InvChoicesButtons extends React.Component<InvChoicesButtonsProps> {
  constructor(props: InvChoicesButtonsProps) {
    super(props);
  }

  public render() {
    return (
      <div className='inv-choices-buttons-wrap'>
        <div className='digital-buttons-wrap'>
          <div
            onClick={this.handleButtonClick(this.props.setDigitalFund, FundTypes.DigitalConservative)}
            className={`${FundTypes.DigitalConservative} inv-choices-button ${this.props.digitalFundSelected === FundTypes.DigitalConservative ? 'selected' : ''}`}>
            {this.props.showTooltips &&
              <Tooltip
                positionX='left'
                positionY='top'
                open={this.props.digitalFundSelected === FundTypes.DigitalConservative}
              >
                <p><b>This is for you if you're primarily looking to protect against capital loss.</b></p>
                <br/>
                <p>Up to 100% of the investment can be protected as cash equivalent.</p>
              </Tooltip>
            }
            <div className='bg-icon'>
              <DigitalIcon />
            </div>
            <div className='inv-choices-button-info'>
              <DigitalConservativeIcon />
              <h6>{i18n.t('tool.inv_choices.conservative')}</h6>
              <p>{i18n.t('tool.inv_choices.digital')}</p>
            </div>
          </div>
          <div
            onClick={this.handleButtonClick(this.props.setDigitalFund, FundTypes.DigitalBalanced)}
            className={`${FundTypes.DigitalBalanced} inv-choices-button ${this.props.digitalFundSelected === FundTypes.DigitalBalanced ? 'selected' : ''}`}>
            {this.props.showTooltips &&
              <Tooltip
                positionY='top'
                open={this.props.digitalFundSelected === FundTypes.DigitalBalanced}
              >
                <p><b>This is for you if you're a more balanced investor.</b></p>
                <br/>
                <p>Up to 100% of your investment can be protected as cash equivalent.</p>
              </Tooltip>
            }
            <div className='bg-icon'>
              <DigitalIcon />
            </div>
            <div className='inv-choices-button-info'>
              <DigitalBalancedIcon />
              <h6>{i18n.t('tool.inv_choices.balanced')}</h6>
              <p>{i18n.t('tool.inv_choices.digital')}</p>
            </div>
          </div>
          <div
            onClick={this.handleButtonClick(this.props.setDigitalFund, FundTypes.DigitalUnconstrained)}
            className={`${FundTypes.DigitalUnconstrained} inv-choices-button ${this.props.digitalFundSelected === FundTypes.DigitalUnconstrained ? 'selected' : ''}`}>
            {this.props.showTooltips &&
              <Tooltip
                positionX='right'
                positionY='top'
                open={this.props.digitalFundSelected === FundTypes.DigitalUnconstrained}
              >
                <p><b>This is for you if you have if an appetite for risk.</b></p>
                <br/>
                <p>Up to 50% of the investment can be protected as cash equivalent.</p>
              </Tooltip>
            }
            <div className='bg-icon'>
              <DigitalIcon />
            </div>
            <div className='inv-choices-button-info'>
              <DigitalUnconstrainedIcon />
              <h6>{i18n.t('tool.inv_choices.unconstrained')}</h6>
              <p>{i18n.t('tool.inv_choices.digital')}</p>
            </div>
          </div>
        </div>

        <div className='capital-buttons-wrap'>
          <div
            onClick={this.handleButtonClick(this.props.setCapitalFund, FundTypes.CapitalConservative)}
            className={`${FundTypes.CapitalConservative} inv-choices-button ${this.props.capitalFundSelected === FundTypes.CapitalConservative ? 'selected' : ''}`}>
            {this.props.showTooltips &&
              <Tooltip
                positionX='left'
                positionY='bottom'
                open={this.props.capitalFundSelected === FundTypes.CapitalConservative}
              >
                <p>This is for you if you're looking for stable growth at moderate levels of volatility.</p>
              </Tooltip>
            }
            <div className='bg-icon'>
              <CapitalIcon />
            </div>
            <div className='inv-choices-button-info'>
              <CapitalConservativeIcon />
              <h6>{i18n.t('tool.inv_choices.conservative')}</h6>
              <p>{i18n.t('tool.inv_choices.capital')}</p>
            </div>
          </div>
          <div
            onClick={this.handleButtonClick(this.props.setCapitalFund, FundTypes.CapitalBalanced)}
            className={`${FundTypes.CapitalBalanced} inv-choices-button ${this.props.capitalFundSelected === FundTypes.CapitalBalanced ? 'selected' : ''}`}>
            {this.props.showTooltips &&
              <Tooltip
                positionY='bottom'
                open={this.props.capitalFundSelected === FundTypes.CapitalBalanced}
              >
                <p>This is for you if you're looking for long-term capital growth.</p>
              </Tooltip>
            }
            <div className='bg-icon'>
              <CapitalIcon />
            </div>
            <div className='inv-choices-button-info'>
              <CapitalBalancedIcon />
              <h6>{i18n.t('tool.inv_choices.balanced')}</h6>
              <p>{i18n.t('tool.inv_choices.capital')}</p>
            </div>
          </div>
          <div
            onClick={this.handleButtonClick(this.props.setCapitalFund, FundTypes.CapitalUnconstrained)}
            className={`${FundTypes.CapitalUnconstrained} inv-choices-button ${this.props.capitalFundSelected === FundTypes.CapitalUnconstrained ? 'selected' : ''}`}>
            {this.props.showTooltips &&
              <Tooltip
                positionX='right'
                positionY='bottom'
                open={this.props.capitalFundSelected === FundTypes.CapitalUnconstrained}
              >
                <p>This is for you if you're willing to put up with short-term market volatility for the potential of greater long-term returns.</p>
              </Tooltip>
            }
            <div className='bg-icon'>
              <CapitalIcon />
            </div>
            <div className='inv-choices-button-info'>
              <CapitalUnconstrainedIcon />
              <h6>{i18n.t('tool.inv_choices.unconstrained')}</h6>
              <p>{i18n.t('tool.inv_choices.capital')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private handleButtonClick = (
    action: (x: FundTypes) => object,
    fund: FundTypes,
  ) => () => action(fund);
};
